import { render } from "./Capture.vue?vue&type=template&id=dc4c3ae2&scoped=true"
import script from "./Capture.vue?vue&type=script&lang=js"
export * from "./Capture.vue?vue&type=script&lang=js"

import "./Capture.vue?vue&type=style&index=0&id=dc4c3ae2&scoped=true&lang=css"

import exportComponent from "/Users/fikri/Work/PRiADI/code/priadi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4c3ae2"]])

export default __exports__